import { IconProps } from './IconProps';

export function CheckCircleIcon(props: IconProps) {
    return (
        <svg
            {...props}
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                <path
                    d="M24 0.5L10.2 17.63C10.112 17.74 10.0017 17.8301 9.87638 17.8945C9.75108 17.9589 9.61359 17.9961 9.47291 18.0037C9.33224 18.0112 9.19155 17.989 9.06008 17.9383C8.9286 17.8877 8.80931 17.8099 8.71 17.71L4.5 13.5"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.7671 12.4891C19.2371 14.4801 19.0147 16.5719 18.1366 18.4196C17.2585 20.2674 15.7772 21.7608 13.9366 22.6538C12.0961 23.5469 10.0062 23.7862 8.0114 23.3324C6.0166 22.8786 4.23593 21.7588 2.96284 20.1574C1.68975 18.556 1.00022 16.5687 1.00788 14.523C1.01553 12.4772 1.71992 10.4951 3.00496 8.90333C4.28999 7.31154 6.079 6.20503 8.07713 5.76618C10.0753 5.32732 12.1633 5.5823 13.9971 6.48909"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
}
